<template>
  <reusable-window ref="reusable">
    <h2 class="text-neon" style="margin-top: 0">{{ title }}</h2>
    <hr class="separador-horizontal" />
    <p style="font-size: 18px" v-html="message"></p>
    <div class="row d-flex justify-content-between text-center" :class="isMobileConfirmation ? '' : 'w-100'">
      <div :class="isMobileConfirmation ? 'col-lg-6' : 'col-lg-6'">
        <a class="btn btn-plain hover-neon red" @click="cancel">{{ cancelButton }}</a>
      </div>
      <div :class="isMobileConfirmation ? 'col-lg-6 mt-2' : 'col-lg-6'">
        <a class="btn btn-plain hover-neon green" @click="confirm">{{ okButton }}</a>
      </div>
    </div>
  </reusable-window>
</template>

<script>
import ReusableWindow from '@snippets/base/ReusableWindow.vue';
import { GlobalMixin } from '@mixins/GlobalMixin';

export default {
  name: 'Confirmation',
  components: { ReusableWindow },
  mixins: [GlobalMixin],
  data: () => ({
    title: undefined,
    message: undefined,
    okButton: undefined,
    cancelButton: undefined,
    isMobileConfirmation: false,
  }),
  methods: {
    show(options = {}) {
      this.title = options.title;
      this.message = options.message;
      this.okButton = options.okButton;
      if (options.cancelButton) {
        this.cancelButton = options.cancelButton;
      }
      return this.$refs.reusable.open();
    },
    confirm() {
      this.$refs.reusable.close(true);
    },
    cancel() {
      this.$refs.reusable.close(false);
    },
  },
  mounted() {
    // ------------ Responsividad ------------
    this.handleResize('isMobileConfirmation', 1024);
    window.addEventListener('resize', () => this.handleResize('isMobileConfirmation', 1024));
    // ------------ Responsividad ------------
  },
};
</script>
